import React from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompPremissasQuery } from 'services/api/products/relatorios';
import EditButton from 'components/Shared/EditButton';
import RichHtml from 'components/RichHtml';

export default function PremissasGerais() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompPremissasQuery(params);

  return (
    <Card className="shadow-sm h-100">
      <Card.Header className="d-flex">
        <div className="flex-fill">
          PREMISSAS GERAIS
        </div>
        {userIsAdmin && (
          <div className="h-100 d-flex align-items-center">
            <EditButton id="edit-premissas-gerais" onClick={() => undefined} />
          </div>
        )}
      </Card.Header>
      <Card.Body>
        {isLoading && (
          <div className="d-flex justify-content-center p-3">
            <Spinner animation="border" role="status" />
          </div>
        )}
        {data && (
          <RichHtml html={data.conteudo_html} className="w-100 ql-editor" />
        )}
      </Card.Body>
    </Card>
  );
}
